import { render, staticRenderFns } from "./thermometer.vue?vue&type=template&id=38b9be31&"
import script from "./thermometer.vue?vue&type=script&lang=js&"
export * from "./thermometer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports